import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    flexGrow: 1
  },
  tabPanel: {
    width: '100%',
    minHeight: '500px'
  }
}));
